export const Monogram = ({ size = 48, className = "" }) => (
  <div
    className={`flex items-center justify-center rounded-full border border-brass text-brass font-serif leading-none select-none ${className}`}
    style={{ width: size, height: size, fontSize: size * 0.4 }}
    data-testid="wa-monogram"
  >
    <span style={{ marginTop: size * 0.03, letterSpacing: "0.01em", fontWeight: 600 }}>WA</span>
  </div>
);

export const Wordmark = ({ className = "" }) => (
  <div className={`leading-tight ${className}`}>
    <div className="font-serif text-ink" style={{ fontSize: "1.35rem", fontWeight: 600, lineHeight: 1 }}>
      Working Actor
    </div>
    <div className="overline mt-1" style={{ fontSize: "0.58rem" }}>
      The Acting Studio of Eliza Roberts
    </div>
  </div>
);
